/**
 * Client Configuration Loader
 *
 * Loads the appropriate client configuration based on REACT_APP_CLIENT environment variable
 * Falls back to default configuration if not specified
 */

import defaultConfig from './default';
import donatorConfig from './donator';
import atacoConfig from './ataco';

// Map of available client configurations
const clientConfigs = {
  default: defaultConfig,
  ataco: atacoConfig,
  donator: donatorConfig,
};

/**
 * Get the current client configuration
 * Reads from REACT_APP_CLIENT environment variable
 *
 * @returns {Object} Client configuration object
 */
export const getClientConfig = () => {
  const clientId = process.env.REACT_APP_CLIENT || 'default';

  const config = clientConfigs[clientId.toLowerCase()];

  if (!config) {
    console.warn(
      `[ClientConfig] Unknown client: "${clientId}". Falling back to default configuration.`,
    );
    return defaultConfig;
  }

  console.log(`[ClientConfig] Loaded configuration for client: "${clientId}"`);
  return config;
};

/**
 * Get a specific configuration value by path
 * Example: getConfigValue('currency.code') returns 'KM' or 'EUR'
 *
 * @param {string} path - Dot-separated path to config value
 * @param {*} defaultValue - Default value if path not found
 * @returns {*} Configuration value
 */
export const getConfigValue = (path, defaultValue = null) => {
  const config = getClientConfig();

  const keys = path.split('.');
  let value = config;

  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return defaultValue;
    }
  }

  return value;
};

/**
 * Export individual configs for direct import if needed
 */
export { defaultConfig, donatorConfig, atacoConfig };

/**
 * Export the active configuration as default
 */
export default getClientConfig();
